/* eslint-disable @typescript-eslint/no-magic-numbers */
interface IRes {
  day: number | string;
  hour: number | string;
  minute: number | string;
  second: number | string;
  msecond: number | string;
  total_hour: number | string;
}

// 比较时间戳相距时间
export function diffTime(count: number) {
  if (count === 0) {
    return {
      day: '00',
      hour: '00',
      minute: '00',
      second: '00',
      total_hour: '00',
      stopFlag: true,
    };
  }

  // 毫秒数
  const s = 1000;
  const m = s * 60;
  const h = m * 60;
  const d = h * 24;

  let day: number | string = Math.floor(count / d);
  let hour: number | string = Math.floor((count % d) / h);
  let minute: number | string = Math.floor((count % h) / m);
  let second: number | string = Math.floor((count % m) / s);
  let msecond: number | string = Math.floor(count % s);
  let total_hour: number | string = day <= 0 ? hour : day * 24 + hour;

  if (day < 10) {
    day = '0' + day;
  }
  if (hour < 10) {
    hour = '0' + hour;
  }
  if (minute < 10) {
    minute = '0' + minute;
  }
  if (second < 10) {
    second = '0' + second;
  }
  if (!msecond) {
    msecond = 0;
  }
  if (total_hour < 10) {
    total_hour = '0' + total_hour;
  }

  return {
    day,
    hour,
    minute,
    second,
    msecond,
    total_hour,
  };
}

// 倒计时
export function countDown(
  config: { count: number; interval: number },
  cb: (obj: IRes) => void
) {
  class Timer {
    private count = 0;
    private interval = 1000;
    private cb: (res: any) => void = () => {};
    private timer: any = null;
    private stopFlag = false;

    constructor({ count = 0, interval = 1000 }, cb: (obj: IRes) => void) {
      this.count = count;
      this.interval = interval;
      this.cb = cb;
      this.timer = null;
      this.stopFlag = false;
      this.start();
    }

    public start(): boolean | void {
      if (this.timer) {
        return false;
      }

      this.stopFlag = false;
      this.loop();
    }

    public loop(): boolean | void {
      if (this.stopFlag) {
        return false;
      }

      this.timer = setTimeout(() => {
        const res = diffTime(this.count);
        this.cb && this.cb(res);
        if (this.stopFlag) {
          this.stop();
        } else {
          this.count -= this.interval;
          this.loop();
        }
      }, this.interval);
    }

    public stop() {
      this.timer = null;
      this.stopFlag = true;
    }
  }

  return new Timer(config, cb);
}
